module.exports = __webpack_public_path__ + "img/info.d2c103e5.svg";